/**
 * Visibility status values for products.
 *
 * Controls whether a product is displayed to end users.
 * This is a binary flag — the reason for hiding is not tracked at this layer.
 *
 * Visibility is resolved by the Panel plugin layer (single source of truth),
 * not parsed directly from CRM responses in the app.
 */
export const VISIBILITY_STATUS = {
  VISIBLE: 'visible',
  HIDDEN:  'hidden',
}
